import { Observable, ObservableInput } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'
import { processError } from 'helpers/ajaxHelpers'
import { Action } from 'actions'

/**
 * @deprecated Use ajaxCatch instead
 * */
export const mapSafe = <T, R>(project: (value: T, index: number) => R, thisArg?: any) => (source: Observable<T>) => {
  return source.pipe(
    map(project, thisArg),
    catchError((error) => processError(error, false))
  ) as Observable<R | Action>
}

/**
 * @deprecated Use ajaxCatch instead
 * */
export const mergeMapSafe = <T, R>(project: (value: T, index: number) => ObservableInput<R>, concurrent?: number) => (source: Observable<T>) => {
  return source.pipe(
    mergeMap(project, concurrent),
    catchError((error) => processError(error, false)),
  ) as Observable<R | Action>
}
